/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLoginAttemptsByDeviceUuid} from '../api'

 export const useQueryGetLoginAttemptsByDeviceUuid = createReactQueryHook('getLoginAttemptsByDeviceUuid', getLoginAttemptsByDeviceUuid)
